import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OfflineComponent } from './standalone-components/offline/offline.component';
import { ErrorPageComponent } from './modules/pages/error-page/error-page.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./standalone-components/new-homepage/new-homepage-skelet/new-homepage-skelet.component')
        .then(m => m.NewHomepageSkeletComponent),
  },
  {
    path: 'offline',
    component: OfflineComponent,
  },
  {
    path: 'Modal_password_forgot',
    redirectTo: 'Misc_auth_module/Modal_password_forgot',
    pathMatch: 'full'
  },
  {
    path: 'Auth_password_change',
    redirectTo: 'Misc_auth_module/Auth_password_change',
    pathMatch: 'full'
  },
  {
    path: 'Modal_password_forgot_confirmation',
    redirectTo: 'Misc_auth_module/Modal_password_forgot_confirmation',
    pathMatch: 'full'
  },
  {
    path: 'Auth_email_verify',
    redirectTo: 'Misc_auth_module/Auth_email_verify',
    pathMatch: 'full'
  },
  {
    path: 'Auth_email_change_successful',
    redirectTo: 'Misc_auth_module/Auth_email_change_successful',
    pathMatch: 'full'
  },
  {
    path: 'Misc_auth_module',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'Misc_tutor_search',
    loadChildren: () => import('./modules/pages/tutor-search-page/tutor-search-page.module').then(m => m.TutorSearchPageModule)
  },
  {
    path: 'Navigation_edit_profile_student',
    redirectTo: 'Misc_edit_profile_module/Navigation_edit_profile_student',
    pathMatch: 'full'
  },
  {
    path: 'Misc_tutor_edit_profile',
    redirectTo: 'Misc_edit_profile_module/Misc_tutor_edit_profile',
    pathMatch: 'full'
  },
  {
    path: 'Misc_edit_profile_module',
    loadChildren: () => import('./modules/edit-profile/edit-profile.module').then(m => m.EditProfileModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'Misc_overview',
    loadChildren: () => import('./modules/overview/overview.module').then(m => m.OverviewModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'Misc_subscription', // TODO to be accessible by students only
    loadChildren: () => import('./modules/pages/subscription/subscription.module').then(m => m.SubscriptionModule)
  },
  {
    path: 'Misc_introducing',
    data: { fullscreenFlow: true },
    loadComponent: () =>
      import('./standalone-components/introducing-flow/introducing-flow-skelet/introducing-flow-skelet.component')
        .then(m => m.IntroducingFlowSkeletComponent),
  },
  {
    path: 'Misc_packages',
    data: { fullscreenFlow: true },
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./standalone-components/packages/full-screen-packages-skelet/full-screen-packages-skelet.component')
        .then(m => m.FullScreenPackagesSkeletComponent),
  },
  {
    path: 'Misc_search_dialog',
    data: { fullscreenFlow: true },
    loadComponent: () =>
      import('./standalone-components/search-dialog/search-dialog.component')
        .then(m => m.SearchDialogComponent),
  },
  {
    path: 'Misc_tutoring_online',
    loadComponent: () => import('./standalone-components/online-tutoring-page/online-tutoring-page-skelet/online-tutoring-page-skelet.component').then(c => c.OnlineTutoringPageSkeletComponent),
  },
  {
    path: 'Misc_become_tutor',
    loadChildren: () => import('./modules/pages/tutor-landing-page/tutor-landing-page.module').then(m => m.TutorLandingPageModule)
  },
  {
    path: 'Misc_tutor_academy',
    loadChildren: () => import('./standalone-components/tutor-academy/tutor-academy.routes').then(m => m.TUTOR_ACADEMY_ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: 'Login_page',
    loadComponent: () => import('./standalone-components/login-page/login-page.component').then(c => c.LoginPageComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./standalone-components/login-page/login-page.component').then(c => c.LoginPageComponent),
  },
  {
    path: 'Register_page',
    loadComponent: () => import('./standalone-components/register-page/register-page.component').then(c => c.RegisterPageComponent),
  },
  {
    path: 'Misc_Invoices_Page',
    loadComponent: () => import('./standalone-components/invoice-page/invoice-page-frame/invoice-page-frame.component').then(c => c.InvoicePageFrameComponent),
  },
  {
    path: 'success',
    loadComponent: () => import('./standalone-components/payment-success/payment-success.component').then(c => c.PaymentSuccessComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'cancel',
    loadComponent: () => import('./standalone-components/payment-cancel/payment-cancel.component').then(c => c.PaymentCancelComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'evaluate/:token',
    loadComponent: () => import('./standalone-components/progress/evaluate-page/evaluate-page.component').then(c => c.EvaluatePageComponent),
    canActivate: [AuthGuard],
    data: { alwaysRefresh: true }
  },
  {
    path: 'Navigation_messages',
    loadChildren: () => import('./modules/pages/new-chat/new-chat.routes').then(m => m.NEW_CHAT_ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: 'Misc_ms_booking',
    loadChildren: () => import('./modules/msbooking/msbooking.module').then(m => m.MSBookingModule)
  },
  {
    path: 'Misc_Pricing',
    loadComponent: () => import('./standalone-components/new-pricing-page/new-pricing-page-skelet/new-pricing-page-skelet.component').then(c => c.NewPricingPageSkeletComponent),
  },
  {
    path: 'Misc_dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'Misc_relation',
    loadChildren: () => import('./modules/relation/relation.module').then(m => m.RelationModule)
  },
  {
    path: 'Misc_profile',
    loadChildren: () => import('./modules/pages/tutor-profile/tutor-profile.module').then(m => m.TutorProfileModule)
  },
  {
    path: '401',
    component: ErrorPageComponent,
    data: { error: 401 }
  },
  {
    path: '403',
    component: ErrorPageComponent,
    data: { error: 403 }
  },
  {
    path: '404',
    component: ErrorPageComponent,
    data: { error: 404 }
  },
  {
    path: '500',
    component: ErrorPageComponent,
    data: { error: 500 }
  },
  {
    path: 'reg2',
    loadComponent: () =>
      import('./standalone-components/student-login-or-register/tutor-registration/tutor-registration-second-part-frame/tutor-registration-second-part-frame.component')
        .then((m) => m.TutorRegistrationSecondPartFrameComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'Misc_5_lesson_package',
    loadComponent: () =>
      import('./standalone-components/package-pages/lesson-5-package/lesson-5-package.component')
        .then((m) => m.Lesson5PackageComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'Misc_lesson_regular_package',
    loadComponent: () =>
      import('./standalone-components/package-pages/lesson-regular-packages/lesson-regular-packages.component')
        .then((m) => m.LessonRegularPackagesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'Misc_alternative_package',
    loadComponent: () =>
      import('./standalone-components/package-pages/lesson-alternative-packages/lesson-alternative-packages.component')
        .then((m) => m.LessonAlternativePackagesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'oauth',
    loadComponent: () =>
      import('./standalone-components/oauth-login/oauth.component')
        .then((m) => m.OauthComponent),
  },
  {
    path: 'new-homepage',
    loadComponent: () =>
      import('./standalone-components/new-homepage/new-homepage-skelet/new-homepage-skelet.component')
        .then(m => m.NewHomepageSkeletComponent),
  },
  {
    path: 'Misc_Homepage_Test_Version',
    loadComponent: () =>
      import('./standalone-components/landing-pages/homepage-test-version/homepage-test-version.component')
        .then(m => m.HomepageTestVersionComponent),
  },
  {
    path: 'voorwaarden',
    loadComponent: () =>
      import('./standalone-components/terms-and-conditions/terms-and-conditions.component')
        .then(m => m.TermsAndConditionsComponent),
  },
  {
    path: '*/*',
    redirectTo: '/',
    pathMatch: 'full',
  },
  {
    path: '**',
    loadComponent: () =>
      import('./standalone-components/strapi/renderers/cms-router/cms-router.component')
        .then(m => m.CmsRouterComponent),
    data: { onSameUrlNavigation: 'reload', skipLocationChange: false },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'disabled',
      useHash: false,
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
